module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu",
    staticStyle: {
      "background": "url(static/images/backgroundcs.png) no-repeat bottom",
      "background-color": "#A7D7F5",
      "background-size": "100%",
      "height": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "grid margin-top-10"
  }, [_c('div', {
    staticClass: "gridWarp nopadding noborder"
  }, [_c('div', {
    staticClass: "gridCell lof-3",
    on: {
      "click": function($event) {
        return _vm.checkPermissionOpenPage()
      }
    }
  }, [_c('div', {
    staticClass: "btimg d_icon_10",
    staticStyle: {
      "background": "url(static/images/jt.png) no-repeat",
      "background-size": "333.33%",
      "background-color": "#3C8DFF"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("联合查询")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topLogo"
  }, [_c('img', {
    staticClass: "leftLogo",
    attrs: {
      "src": "static/images/logoblack.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "rightLogo",
    attrs: {
      "src": "static/images/wsbsdt.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a0fc17a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/indexMenuJointQuery.vue
// module id = 836
// module chunks = 1